import React, { useEffect, useState } from 'react';

import Config from '@skin_config';

import FavoriteCompetitions from './components/favoriteCompetitions';
import HomePopularGames from './components/popularGames';
import HomeCasinoGames from './components/casinoGames';
import MediaSlider from './components/mediaSlider';
import HomeShortPages from './components/pages';
import Banner from './components/banner';
import LiveGameBanner from './components/liveGameBanner';

import './style.scss';

const Home = () => {
  const [isVertical, setIsVertical] = useState(window.innerWidth < window.innerHeight);
  const homeConfig = isVertical ? Config.verticalHome : Config.home;
  const templateAreas = homeConfig.grid.map((row) => `"${row.join(' ')}"`).join('');
  const hasSection = (sectionName) => homeConfig.grid.some((row) => row.includes(sectionName));

  useEffect(() => {
    const handleResize = () => setIsVertical(window.innerWidth < window.innerHeight);

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section className="home-page">
      <div
        className="home-page"
        style={{
          gridTemplateAreas: templateAreas,
          gridTemplateColumns: homeConfig.gridColumns,
          gridTemplateRows: homeConfig.gridRows,
        }}
      >
        {hasSection('shortpages') && <HomeShortPages />}
        {hasSection('slider') && <MediaSlider />}
        {hasSection('banner') && <Banner />}
        {hasSection('liveGameBanner') && <LiveGameBanner />}
        {hasSection('comp') && <FavoriteCompetitions />}
        {hasSection('populargames') && <HomePopularGames />}
        {hasSection('casinogames') && <HomeCasinoGames />}
      </div>
    </section>
  );
};

export default Home;
